import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

// Generic confirm-before-write dialog. `children` renders the exact change preview.
export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel, danger,
                                requireNote, notePlaceholder, onConfirm, children, testid }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setNote(""); }, [open]);
  const blocked = requireNote && note.trim().length < 3;
  const go = async () => {
    setBusy(true);
    try { await onConfirm(note.trim()); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="text-[#0A2540]">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="space-y-3">{children}</div>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2}
                  placeholder={notePlaceholder || "Note for the audit log"} data-testid={`${testid}-note`} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testid}-cancel`}>Cancel</Button>
          <Button onClick={go} disabled={busy || blocked} data-testid={`${testid}-confirm`}
                  className={danger ? "bg-[#B91C1C] hover:bg-[#991B1B] text-white" : "bg-[#0066FF] hover:bg-[#0052CC] text-white"}>
            {busy ? "Working…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
